module.exports = __webpack_public_path__ + "img/search-for-information.a007b1c8.svg";